import { Box, BoxProps, Divider, Stack, VStack } from "@chakra-ui/react"
import { Field, FieldProps, FormikProps, FormikValues } from "formik"
import { FormInputField } from "../../../components/formInputField/FormInputField";
import { FormSubSectionHeader } from "../../../components/formSubSectionHeader/FormSubSectionHeader";
import { IFormDataClassField } from "../../../utils/formsSchema/FormDataClass"
import { GamCampaignFormDataClass } from "./gamCampaignFormSchema";

interface Props {
    fields: Record<string, IFormDataClassField>;
    formik: FormikProps<FormikValues>;
    defaultValues: Record<string, any>;
    gamCampaignFormData: GamCampaignFormDataClass;
}

export const GamCampaignOwnerEmail = ({
    formik,
    fields,
    defaultValues,
    gamCampaignFormData,
    ...boxProps
}: Props & BoxProps) => {

    const { packageOwnerEmail } = gamCampaignFormData.getUserDetailsFields();

    return (
        <Box {...boxProps}>
            <FormSubSectionHeader label={"User Details"} />
            <Divider mt={0} mb={4} />
            <Stack align={"flex-start"} width={"100%"} direction="row">
                <VStack w="100%">
                    <Field name={"packageOwnerEmail"}>
                        {({ field, form }: FieldProps) => (
                            <FormInputField
                                mt={0}
                                inputFieldProps={{
                                    ...field,
                                    variant: "greyInput",
                                }}
                                fieldType={
                                    packageOwnerEmail.inputFormat as
                                    | "email"
                                    | "text"
                                    | "password"
                                }
                                isRequired={packageOwnerEmail.isRequired}
                                label={packageOwnerEmail.label}
                                isInvalid={
                                    !!(
                                        form.errors["packageOwnerEmail"] &&
                                        form.touched["packageOwnerEmail"]
                                    )
                                }
                                placeholder={packageOwnerEmail.placeholder}
                                errorMessage={form.errors?.packageOwnerEmail?.toString()}
                                isAdmin={true}
                            />
                        )}
                    </Field>
                </VStack>
            </Stack>
        </Box>
    )
}
